// extracted by mini-css-extract-plugin
export default {"tabsSectionContainer":"TabsSection_tabsSectionContainer__j5Avb"};